var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('app-header'),_c('div',{staticClass:"page-wrap"},[_c('sidebar'),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)]),_c('full-features'),_c('AppFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }